import { render } from "./ChartData.vue?vue&type=template&id=d6523d96&scoped=true"
import script from "./ChartData.vue?vue&type=script&lang=js"
export * from "./ChartData.vue?vue&type=script&lang=js"

import "./ChartData.vue?vue&type=style&index=0&id=d6523d96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6523d96"]])

export default __exports__